import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../redux/store";
import { QueryStatus, axiosInstanceWithPhoneToken } from "../../../utils";
import { CreateInitialVehicleRestitutionPayload } from "./vehicleSessionsApi";

export interface VehicleSessionsState {
  createInitialVehicleRestitutionStatus: QueryStatus;
}

const initialState: VehicleSessionsState = {
  createInitialVehicleRestitutionStatus: "idle",
};

export const createInitialVehicleRestitutionAsync = createAsyncThunk(
  "vehicleSessions/createInitial",
  async (payload: CreateInitialVehicleRestitutionPayload) => {
    const phoneToken = localStorage.getItem("phoneToken");
    if (!phoneToken) throw new Error();
    const axios = axiosInstanceWithPhoneToken(phoneToken);
    await axios.post("/vehicle_restitution", payload);
  },
);

export const vehicleSessionsSlice = createSlice({
  name: "vehicle_sessions",
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.createInitialVehicleRestitutionStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createInitialVehicleRestitutionAsync.pending, (state) => {
        state.createInitialVehicleRestitutionStatus = "processing";
      })
      .addCase(createInitialVehicleRestitutionAsync.fulfilled, (state) => {
        state.createInitialVehicleRestitutionStatus = "success";
      })
      .addCase(createInitialVehicleRestitutionAsync.rejected, (state) => {
        state.createInitialVehicleRestitutionStatus = "failed";
      });
  },
});

export const selectCreateInitialVehicleRestitutionStatus = (state: RootState) =>
  state.vehicleSessions.createInitialVehicleRestitutionStatus;

export default vehicleSessionsSlice.reducer;
